import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { shippingInfoStyles as styles } from "@waytek/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitShippingInfo";
import { colorStrings } from "@waytek/Utilities/variables";
import { css } from "styled-components";

styles.accordionSection = {
    css: css`
        margin: 10px 0 40px;
    `,
};

styles.shippingInfoAccordionSection = {
    ...styles.shippingInfoAccordionSection,
    mergeCss: true,
    headerProps: {
        ...styles.shippingInfoAccordionSection?.headerProps,
        color: colorStrings.commonGlobalWhite,
        css: css`
            ${styles.shippingInfoAccordionSection?.headerProps?.css}

            &&& {
                button {
                    border-color: ${getColor(colorStrings.commonBorder)};
                    background: ${getColor(colorStrings.commonGlobalWhite)};
                    padding: 0 9px 0 14px;

                    ${TypographyStyle} {
                        color: ${getColor(colorStrings.commonGlobalDarkerGray)};
                        font-size: 14px;
                        font-weight: 400;
                        line-height: 38px;
                    }

                    &:focus {
                        padding: 0 9px 0 14px;
                    }
                }
            }
        `,
    },
    toggleIconProps: {
        color: colorStrings.commonGlobalGuardianBlue,
        size: 20,
    },
    panelProps: {
        ...styles.shippingInfoAccordionSection?.panelProps,
        css: css`
            ${styles.shippingInfoAccordionSection?.panelProps?.css}
            border-color: ${getColor(colorStrings.commonBorder)};
        `,
    },
};

styles.billingAndShippingInfoExtendedStyle = {
    ...styles.billingAndShippingInfoExtendedStyle,
    carrierGridItem: {
        css: css`
            display: none;
        `,
    },
    shippingServiceGridItem: {
        css: css`
            display: none;
        `,
    },
    deliveryDateGridItem: {
        css: css`
            display: none;
        `,
    },
};
